import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  employees: localStorage.getItem("employeesData")
    ? JSON.parse(localStorage.getItem("employeesData"))
    : [],
  editEmployeeData: null,
  isUpdateEmployees: false,
};

const employeesSlice = createSlice({
  name: "employees",
  initialState,
  reducers: {
    setEmployees: (state, action) => {
      state.employees = action.payload;
    },
    setEditEmployeeData: (state, action) => {
      state.editEmployeeData = action.payload;
    },
    setIsUpdateEmployees: (state, action) => {
      state.isUpdateEmployees = action.payload;
    },
  },
});

export const { setEmployees, setEditEmployeeData, setIsUpdateEmployees } = employeesSlice.actions;

export default employeesSlice.reducer;
